import { api } from '../../lib/api-client';

export type CertificationItem = {
  /** `CandidateCertification.PublicKey` Guid. */
  id: string;
  name: string;
  /**
   * Entidad emisora (ej: "Amazon Web Services"). Null si el toggle
   * `ShowCertificationsIssuer` está off en visibility settings.
   */
  issuer: string | null;
  /** ISO datetime; null si no fue informado. */
  dateObtained: string | null;
  /**
   * ISO datetime de expiración; null si el cert no expira O si el toggle
   * `ShowCertificationsExpiration` está off en visibility settings.
   */
  expirationDate: string | null;
};

export type CertificationsResponse = {
  items: CertificationItem[];
};

export type GetTalentCertificationsParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export async function getTalentCertifications(
  params: GetTalentCertificationsParams,
): Promise<CertificationsResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/certifications`;
  return api.get<CertificationsResponse>(url);
}
